import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { installE2eBrowserBridges } from './testing/e2e-browser-bridges';

import * as allIcons from 'ionicons/icons';
import { addIcons } from 'ionicons';

// Register all icons globally
addIcons(allIcons);

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    installE2eBrowserBridges(appRef);
  })
  .catch((error: unknown) => {
    throw error;
  });
